import pagination from '@/helpers/pagination';
import collect from './collect/model';

export default {
    ...pagination('sharedServices').model,
    collect,
};
